export class Debouncer {
  timerId: number | null = null
  bounce(callback: () => any, delay: number = 850) {
    if (this.timerId) {
      clearTimeout(this.timerId)
    }
    this.timerId = window.setTimeout(callback, delay)
  }
}
